import React, { useState } from 'react';
import { X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const DeleteAccountScreen = () => {
  const navigate = useNavigate();
  const [selectedReason, setSelectedReason] = useState('');

  const reasons = [
    'Nu îmi mai folosesc contul',
    'Serviciul este prea scump',
    'Vreau să îmi schimb numărul de telefon',
    'Nu înțeleg cum se folosește serviciul',
    'Serviciul nu este disponibil în orașul meu',
    'Alt motiv'
  ];

  const handleBack = () => {
    navigate(-1);
  };

  const handleDeleteAccount = () => {
    // Handle account deletion logic here
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Header */}
      <div className="p-4">
        <button onClick={handleBack} className="p-2 -ml-2">
          <X className="w-6 h-6 text-gray-800" />
        </button>
      </div>

      <div className="px-4 flex-1">
        <h1 className="text-3xl font-bold mb-2">Șterge contul</h1>
        
        <p className="text-gray-600 mb-8">
          Ne pare rău că pleci 😢 Ești sigur că vrei să-ți ștergi contul? Odată ce confirmi, datele tale vor fi șterse.
        </p>

        <div className="space-y-4">
          {reasons.map((reason) => (
            <label 
              key={reason} 
              className="flex items-center p-4 border-b border-gray-100 cursor-pointer"
            >
              <input
                type="radio"
                name="deleteReason"
                value={reason}
                checked={selectedReason === reason}
                onChange={(e) => setSelectedReason(e.target.value)}
                className="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500"
              />
              <span className="ml-3 text-gray-700">{reason}</span>
            </label>
          ))}
        </div>
      </div>

      {/* Delete Button */}
      <div className="p-4 mt-auto">
        <button
          onClick={handleDeleteAccount}
          disabled={!selectedReason}
          className={`w-full py-4 rounded-xl font-medium text-white 
            ${selectedReason 
              ? 'bg-red-500 hover:bg-red-600' 
              : 'bg-gray-300'
            } transition-colors`}
        >
          Șterge contul
        </button>
      </div>
    </div>
  );
};

export default DeleteAccountScreen;